const doc = [({"corrected":"Korrektur-Rechnung", "regular":"Rechnung", "reversal":"Storno-Rechnung"})];
module.exports = doc.length <= 1 ? doc[0] : doc;